<template>
  <b-container>
    <b-col class="text-left">
      <router-link :to="{ name: 'SiteInfo' }">
        <b-button pill variant="purple" class="ml-1 mb-1"
        > بازگشت به صفحه تنظیمات
        </b-button
        >
      </router-link>
    </b-col>

    <form @submit.prevent="onSubmit">

      <b-form-row v-if="isIcon">
        <b-col lg="12" class="mt-5 mb-5 ml-auto mr-auto">
          <form-group class="col text-center Font" :validations="$v.form.icon">
            <div slot-scope="{ errors, invalid }">
              <b-form-file
                  browse-text="انتخاب عکس"
                  @change="onFileChange"
                  class="text-center"
                  v-model="form.icon"
                  placeholder="انتخاب عکس"
                  drop-placeholder="انتخاب عکس">
              </b-form-file>

              <input id="icon-image" type="hidden" @change="onFileChange"/>

              <div id="preview" class="mt-2">
                <img alt="" v-if="form.preview" width="300" height="300" :src="form.preview"/>
              </div>

              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>
        </b-col>
      </b-form-row>

      <b-form-row v-else-if="isOrderAudioNotification">
        <b-col lg="12" class="mt-5 mb-5 ml-auto mr-auto">

          <b-form-file
              browse-text="انتخاب فایل"
              class="text-center"
              v-model="form.file"
              placeholder="انتخاب فایل"
              drop-placeholder="انتخاب فایل">
          </b-form-file>

        </b-col>
      </b-form-row>


      <b-form-row v-else-if="isOrderVerificationAccess">
        <b-col lg="12" class="mt-5 mb-5 ml-auto mr-auto">
          <select v-model="form.value" class="custom-select">
            <option value="">انتخاب کنید</option>
            <option v-for="(item,index) in orderVerificationAccess" :key="index" :value="index">{{ item }}</option>
          </select>
        </b-col>
      </b-form-row>


      <b-form-row v-else-if="isDashboardVerificationAccess">
        <b-col lg="12" class="mt-5 mb-5 ml-auto mr-auto">
          <select v-model="form.value" class="custom-select">
            <option value="">انتخاب کنید</option>
            <option v-for="(item,index) in dashboardVerificationAccess" :key="index" :value="index">{{ item }}</option>
          </select>
        </b-col>
      </b-form-row>

      <b-form-row v-else-if="isCartType">
        <b-col lg="12" class="mt-5 mb-5 ml-auto mr-auto">
          <select v-model="form.value" class="custom-select">
            <option value="">انتخاب کنید</option>
            <option v-for="(item,index) in cartType" :key="index" :value="index">{{ item }}</option>
          </select>
        </b-col>
      </b-form-row>

      <b-form-row v-else-if="isRegisterType">
        <b-col lg="12" class="mt-5 mb-5 ml-auto mr-auto">
          <select v-model="form.value" class="custom-select">
            <option value="">انتخاب کنید</option>
            <option v-for="(item,index) in registerType" :key="index" :value="index">{{ item }}</option>
          </select>
        </b-col>
      </b-form-row>


      <b-form-row v-else-if="isGateStatus">
        <b-col lg="12" class="mt-5 mb-5 ml-auto mr-auto">
          <select v-model="form.value" class="custom-select">
            <option value="">انتخاب کنید</option>
            <option v-for="(item,index) in gateStatus" :key="index" :value="index">{{ item }}</option>
          </select>
        </b-col>
      </b-form-row>

      <b-form-row v-else-if="isOrderOnUnAuthenticatedShoppingCart">
        <b-col lg="12" class="mt-5 mb-5 ml-auto mr-auto">
          <select v-model="form.value" class="custom-select">
            <option value="">انتخاب کنید</option>
            <option v-for="(item,index) in OrderOnUnAuthenticatedShoppingCart" :key="index" :value="index">{{
                item
              }}
            </option>
          </select>
        </b-col>
      </b-form-row>

      <b-form-row v-else-if="isLoginOptions">
        <b-col lg="12" class="mt-5 mb-5 ml-auto mr-auto">
          <select v-model="form.value" class="custom-select">
            <option value="">انتخاب کنید</option>
            <option v-for="(item,index) in LoginOptions" :key="index" :value="index">{{
                item
              }}
            </option>
          </select>
        </b-col>
      </b-form-row>

      <b-form-row v-else-if="isDeliveryOptions">
        <b-col lg="12" class="mt-5 mb-5 ml-auto mr-auto">
          <select v-model="form.value" class="custom-select">
            <option value="">انتخاب کنید</option>
            <option v-for="(item,index) in DeliveryOptions" :key="index" :value="index">{{ item }}</option>
          </select>
        </b-col>
      </b-form-row>

      <b-form-row v-else-if="isLoanOptions">
        <b-col lg="12" class="mt-5 mb-5 ml-auto mr-auto">
          <select v-model="form.value" class="custom-select">
            <option value="">انتخاب کنید</option>
            <option v-for="(item,index) in LoanOptions" :key="index" :value="index">{{ item }}</option>
          </select>
        </b-col>
      </b-form-row>

      <b-form-row v-else-if="isRescueMode">
        <b-col lg="12" class="mt-5 mb-5 ml-auto mr-auto">
          <select v-model="form.value" class="custom-select">
            <option value="">انتخاب کنید</option>
            <option v-for="(item,index) in RescueOption" :key="index" :value="index">{{ item }}</option>
          </select>
        </b-col>
      </b-form-row>

      <b-form-row v-else-if="isChatAccessMode">
        <b-col lg="12" class="mt-5 mb-5 ml-auto mr-auto">
          <select v-model="form.value" class="custom-select">
            <option value="">انتخاب کنید</option>
            <option v-for="(item,index) in ChatAccessOptions" :key="index" :value="index">{{ item }}</option>
          </select>
        </b-col>
      </b-form-row>

      <b-form-row v-else-if="isChatActivityMode">
        <b-col lg="12" class="mt-5 mb-5 ml-auto mr-auto">
          <select v-model="form.value" class="custom-select">
            <option value="">انتخاب کنید</option>
            <option v-for="(item,index) in ChatActivityOptions" :key="index" :value="index">{{ item }}</option>
          </select>
        </b-col>
      </b-form-row>

      <b-form-row v-else-if="isSendSmsAfterTwoStepLogin">
        <b-col lg="12" class="mt-5 mb-5 ml-auto mr-auto">
          <select v-model="form.value" class="custom-select">
            <option value="">انتخاب کنید</option>
            <option v-for="(item,index) in sendSmsAfterTwoStepLogin" :key="index" :value="index">{{
                item
              }}
            </option>
          </select>
        </b-col>
      </b-form-row>

      <b-form-row v-else-if="isShowUsersOrdersInMainDashboard">
        <b-col lg="12" class="mt-5 mb-5 ml-auto mr-auto">
          <select v-model="form.value" class="custom-select">
            <option value="">انتخاب کنید</option>
            <option v-for="(item,index) in showUsersOrdersInMainDashboard" :key="index" :value="index">{{
                item
              }}
            </option>
          </select>
        </b-col>
      </b-form-row>


      <b-form-row v-else-if="isShowPreFactor">
        <b-col lg="12" class="mt-5 mb-5 ml-auto mr-auto">
          <select v-model="form.value" class="custom-select">
            <option value="">انتخاب کنید</option>
            <option v-for="(item,index) in showPreFactorOptions" :key="index" :value="index">{{
                item
              }}
            </option>
          </select>
        </b-col>
      </b-form-row>


      <b-form-row v-if="isProfileFillRequirementMode">
        <b-col lg="12" class="mt-5 mb-5 ml-auto mr-auto">
          <select v-model="form.value" class="custom-select">
            <option value="">انتخاب کنید</option>
            <option v-for="(item,index) in ProfileFillRequirementOptions" :key="index" :value="index">{{
                item
              }}
            </option>
          </select>
        </b-col>
      </b-form-row>


      <form-group v-if="isCashOnDeliveryCategories"
                  class="col-lg-12"
                  :validations="$v.form.value">
        <div slot-scope="{ errors, invalid }">


          <p>نام دسته بندی</p>
          <select v-model="form.value" class="custom-select">
            <option v-for="(category,index) in flatCategories(categories)" :value="category.id">
              {{ category.name }}
            </option>
          </select>

          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>

      <b-form-row v-else-if="isDefaultLanguage">
        <b-col lg="12" class="mt-5 mb-5 ml-auto mr-auto">
          <select v-model="form.value" class="custom-select">
            <option value="">انتخاب کنید</option>
            <option v-for="language in languages" :key="language.id" :value="language.id">{{ language.name }}</option>
          </select>
        </b-col>
      </b-form-row>

      <b-form-row v-else-if="isSmsPanelSettings">
        <b-col lg="12" class="mt-3">
          <form-group
              v-if="!editable"
              class="col-lg-6 px-0"
              :validations="$v.form.name">
            <div slot-scope="{ errors, invalid }">
              <label>نام</label>
              <b-form-select v-model="form.name" :options="options"></b-form-select>
              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>
          <sms-panel-settings v-model="form.value"/>
        </b-col>
      </b-form-row>

      <div class="row" v-else>
        <form-group v-if="$router.currentRoute.params.id === undefined || !isFreeCity" class="col-lg-6"
                    :validations="$v.form.name">
          <div slot-scope="{ errors, invalid }">
            <label>نام</label>
            <b-form-select v-model="form.name" :options="options" :disabled="editable"></b-form-select>
            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>

        <div v-if="isFreeCity" class="col-lg-12 mt-2">
          <form-group class="col-lg-12 text-right " :validations="$v.form.province">
            <div slot-scope="{ errors, invalid }">

              <label>استان</label>
              <b-form-input v-model="form.province" debounce="400" autocomplete="off" @update="provinceSearch"
                            list="provinces-list"></b-form-input>

              <datalist id="provinces-list">
                <option v-for="province in provinces" :key="province.id" :value="province.name">{{
                    province.name
                  }}
                </option>
              </datalist>

              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>

          <form-group v-if="isProvinceFill" class="col-lg-12 text-right mt-2 " :validations="$v.form.city">
            <div slot-scope="{ errors, invalid }">
              <label>شهر</label>
              <b-form-input v-model="form.city" debounce="400" @update="citySearch" autocomplete="off"
                            list="cities-list"></b-form-input>

              <datalist id="cities-list">
                <option v-for="city in cities" :key="city.id">{{ city.name }}</option>
              </datalist>

              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>
        </div>

        <div v-if="isDefaultCity" class="col-lg-12 mt-2">
          <form-group class="col-lg-12 text-right " :validations="$v.form.province">
            <div slot-scope="{ errors, invalid }">

              <label>استان</label>
              <b-form-input v-model="form.province" debounce="400" autocomplete="off" @update="provinceSearch"
                            list="provinces-list"></b-form-input>

              <datalist id="provinces-list">
                <option v-for="province in provinces" :key="province.id" :value="province.name">{{
                    province.name
                  }}
                </option>
              </datalist>

              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>

          <form-group v-if="isProvinceFill" class="col-lg-12 text-right mt-2 " :validations="$v.form.city">
            <div slot-scope="{ errors, invalid }">
              <label>شهر</label>
              <b-form-input v-model="form.city" debounce="400" @update="citySearch" autocomplete="off"
                            list="cities-list"></b-form-input>

              <datalist id="cities-list">
                <option v-for="city in cities" :key="city.id">{{ city.name }}</option>
              </datalist>

              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>
        </div>

        <div v-if="isDefaultProvince" class="col-lg-12 mt-2">
          <form-group class="col-lg-12 text-right " :validations="$v.form.province">
            <div slot-scope="{ errors, invalid }">

              <label>استان</label>
              <b-form-input v-model="form.province" debounce="400" autocomplete="off" @update="provinceSearch"
                            list="provinces-list"></b-form-input>

              <datalist id="provinces-list">
                <option v-for="province in provinces" :key="province.id" :value="province.name">{{
                    province.name
                  }}
                </option>
              </datalist>

              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>
        </div>

        <form-group v-if="isDescription_on_payment_page" class="col-lg-6"
                    :validations="$v.form.value">
          <div slot-scope="{ errors, invalid }">
            <label>مقدار</label>
            <textarea v-model="form.value" cols="5" rows="5" type="text" class="form-control"></textarea>
            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>

        <form-group
            v-if="!isProfileFillRequirementMode && !isFreeCity  &&  !isDefaultCity && !isDefaultProvince && !isDescription_on_payment_page"
            class="col-lg-6"
            :validations="$v.form.value">
          <div slot-scope="{ errors, invalid }">
            <label>مقدار</label>
            <input v-model="form.value" type="text" class="form-control">
            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>


      </div>


      <b-btn pill variant="purple" type="submit" class=" mt-2 w-100">
        ثبت
      </b-btn>
    </form>

  </b-container>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import FormGroup from "../../validator/FormGroup";
import {required, numeric, email, url, minLength, maxLength, helpers} from "vuelidate/lib/validators";
import {
  phone,
  telphone,
  phoneStartWith98
} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/VuelidateCustomValidatoins";
import {
  dashboardVerificationAccess,
  orderVerificationAccess,
  cartType,
  registerType,
} from "../SiteInfoVerificationOptions";
import {flatCategories} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Category";

import FormErrorsManager from '../../validator/FormErrorsManager.vue'
import router from "@/router";
import {findObjects} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {gateStatus} from '../GateStatus';
import {OrderOnUnAuthenticatedShoppingCart} from '../OrderOnUnAuthenticatedShoppingCart';
import {DeliveryOptions} from '../DeliveryOptions';
import {LoginOptions} from "../LoginOptions";
import {LoanOptions} from "../LoanOptions";
import {RescueOption} from "../RescueOption";
import {ChatAccessOptions} from "../ChatAccess";
import {ChatActivityOptions} from "../ChatActivity";
import {ProfileFillRequirementOptions} from "../profileFillRequirementOptions";
import {sendSmsAfterTwoStepLogin} from "../sendSmsAfterTwoStepLogin";
import {showUsersOrdersInMainDashboard} from "../showUsersOrdersInMainDashboard";
import {showPreFactorOptions} from "../showPreFactorOptions";
import SmsPanelSettings from "./SmsPanelSettings.vue";

export default {
  name: "SiteInfoForm",
  components: {FormGroup, FormErrorsManager, SmsPanelSettings},
  data() {
    return {
      form: {
        id: '',
        name: '',
        value: '',
        preview: "",
        icon: [],
        free_city_delivery: '',
        province: '',
        city: '',
        file: null
      },
      dashboardVerificationAccess,
      orderVerificationAccess,
      cartType,
      registerType,
      gateStatus,
      OrderOnUnAuthenticatedShoppingCart,
      DeliveryOptions,
      LoginOptions,
      LoanOptions,
      RescueOption,
      ChatAccessOptions,
      ChatActivityOptions,
      ProfileFillRequirementOptions,
      sendSmsAfterTwoStepLogin,
      showUsersOrdersInMainDashboard,
      showPreFactorOptions,
    }
  },
  props: ['submitFunction', 'title', 'editable'],
  validations() {
    if (this.form.name === 'icon' || this.form.name === 'loadingIcon') {
      return {
        form: {
          icon: {required}
        }
      }
    } else if (this.form.name === 'free_city_delivery') {
      return {
        form: {
          province: {required},
          city: {required},
        }
      }
    } else if (this.form.name === 'default_province') {
      return {
        form: {
          province: {required},
        }
      }
    } else if (this.form.name === 'default_city') {
      return {
        form: {
          province: {required},
          city: {required},
        }
      }
    } else {
      return {
        form: {
          name: {required},
          value: this.getDynamicValidation(), // todo dynamic validation for each field
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      attributes: "SiteInfo/getAttributes",
      provinces: "Province/getProvinces",
      cities: "City/getCities",
      languages: "Language/getLanguages",
      categories: "Category/getCategories"
    }),
    isProvinceFill() {
      return findObjects(this.$store.getters['Province/getProvinces'], this.form.province) != null
    },
    filtered() {
      if (this.editable == false) { // if its create
        return Object.entries(this.attributes).filter(function ([key, val], index) {
          return val.create == true;
        })
      }

      return Object.entries(this.attributes);
    },
    options() {
      return this.filtered.map(
          ([key, val], index) => ({value: key, text: val.fa})
      )
    },
    isIcon() {
      return (this.form.name === 'icon' || this.form.name === 'loadingIcon');
    },
    isFreeCity() {
      return (this.form.name == 'free_city_delivery')
    },
    isOrderVerificationAccess() {
      return (this.form.name === 'orderVerificationAccess')
    },
    isDashboardVerificationAccess() {
      return (this.form.name === 'dashboardVerificationAccess')
    },
    isCartType() {
      return (this.form.name === 'cartType')
    },
    isRegisterType() {
      return (this.form.name === 'registerType')
    },
    isDefaultProvince() {
      return (this.form.name == 'default_province')
    },
    isDefaultCity() {
      return (this.form.name == 'default_city')
    },
    isGateStatus() {
      return (this.form.name == 'gate_status')
    },
    isProductUnitWarning() {
      return (this.form.name == 'product_unit_warning')
    },
    isOrderOnUnAuthenticatedShoppingCart() {
      return (this.form.name == 'order_on_unauthenticated_shopping_cart')
    },
    isDeliveryOptions() {
      return (this.form.name == 'delivery_option')
    },
    isLoginOptions() {
      return (this.form.name == 'login_options')
    },
    isDescription_on_payment_page() {
      return (this.form.name == 'description_on_payment_page')
    },
    isLoanOptions() {
      return (this.form.name == 'loan_options')
    },
    isDefaultLanguage() {
      return (this.form.name == 'default_language')
    },
    isRescueMode() {
      return (this.form.name == 'rescue_mode')
    },
    isChatActivityMode() {
      return (this.form.name == 'chat_activity')
    },
    isChatAccessMode() {
      return (this.form.name == 'chat_access')
    },
    isCashOnDeliveryCategories() {
      return (this.form.name == 'cash_on_delivery_categories')
    },
    isProfileFillRequirementMode() {
      return (this.form.name == 'profile_fill_requirement')
    },
    isSendSmsAfterTwoStepLogin() {
      return (this.form.name == 'send_sms_after_two_step_login')
    },
    isShowUsersOrdersInMainDashboard() {
      return (this.form.name == 'show_users_orders_in_main_dashboard')
    },
    isShowPreFactor() {
      return (this.form.name == 'show_pre_factor')
    },
    isOrderAudioNotification() {
      return (this.form.name == 'order_audio_notification')
    },
    isSmsPanelSettings() {
      return (this.form.name == 'sms_panel_settings')
    },
  },
  methods: {
    ...mapActions({
      'provinceSearch': "Province/search"
    }),
    citySearch(words) {
      let province = findObjects(this.$store.getters['Province/getProvinces'], this.form.province).id;
      this.$store.dispatch('City/search', {words, province});
    },
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit() {
      if (this.invalid()) {
        let form = {...this.form}


        if (this.form.name === 'free_city_delivery') {
          form.value = findObjects(this.$store.getters['City/getCities'], form.city).id;
        }

        // default_city

        if (this.form.name === 'default_province') {
          form.value = findObjects(this.$store.getters['Province/getProvinces'], form.province).id;
        }

        if (this.form.name === 'default_city') {
          form.value = findObjects(this.$store.getters['City/getCities'], form.city).id;
        }

        if (this.form.name === 'order_audio_notification') {
          form.value = this.form.file
        }

        if (this.form.name === 'sms_panel_settings') {
          form.value = typeof this.form.value === 'string'
              ? this.form.value
              : JSON.stringify(this.form.value || {api_url: '', templates: {}})
        }

        this.submitFunction(form)
      }
    },
    onFileChange(e) {
      const file = e.target.files[0];

      this.form.icon = file;
      this.form.preview = URL.createObjectURL(file);
    },
    getDynamicValidation() {
      switch (this.form.name) {
        case 'social_media_instagram':
        case 'social_media_pinterest':
        case 'social_media_twitter':
        case 'social_media_linkedin':
        case 'social_media_aparat':
        case 'social_media_telegram':
        case 'social_media_youtube':
        case 'host':
          return {required, url}
        case 'email':
          return {required, email}
        case 'cell_phone':
          return {required, phone}
        case 'social_media_whatsapp':
          return {required, minLength: minLength(13), maxLength: maxLength(13), phoneStartWith98}
        case 'tel_phone':
        case 'fax':
          return {required, telphone}

        case 'deliver_price':
        case 'deliver_free_if_price_bigger_than':
        case 'tax':
          return {required, numeric}
        default:
          return {}
      }
    },
    flatCategories,
  },
  async mounted() {
    await this.$store.dispatch("SiteInfo/getSiteInfos")
    await this.$store.dispatch("Category/getCategories")

    const siteInfoId = router.currentRoute.params.id

    if (siteInfoId !== undefined) {
      this.form.id = siteInfoId;
      const form = this.form
      this.$store.dispatch('SiteInfo/getSiteInfo', form).then(async res => {

        const siteInfo = res.data.data
        this.form.name = await siteInfo.name
        if (this.form.name === 'icon' || this.form.name === 'loadingIcon') {
          this.form.preview = await siteInfo.value
          return true
        }
        if (this.form.name == 'cash_on_delivery_categories') {

          this.form.value = await siteInfo.value.id
          return true
        }
        if (this.form.name == 'default_language') {
          this.form.value = await siteInfo.value.id
          return true
        }
        if (this.form.name === 'sms_panel_settings') {
          const value = siteInfo.value
          if (typeof value === 'string') {
            try {
              this.form.value = JSON.parse(value)
            } catch (e) {
              this.form.value = {api_url: '', templates: {}}
            }
          } else {
            this.form.value = value || {api_url: '', templates: {}}
          }
          return true
        } else if (this.form.name === 'free_city_delivery') {
          this.form.value = await siteInfo.value.id
          this.form.province = await siteInfo.value.province.name
          this.form.city = await siteInfo.value.name

          this.$store.dispatch('Province/search', form.province).then(res => {
            this.$store.dispatch('City/search', {words: form.city, province: siteInfo.value.province.id})
          })
          return true
        } else {
          this.form.value = await siteInfo.value
          return true
        }

      }).catch(err => {
        console.log(err)
        router.push({name: 'SiteInfo'})
      })
    }
  },
}

</script>

<style scoped></style>